import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { codyJanuaryData } from './codyJanuaryData';
import { codyFebruaryData } from './codyFebruaryData';
import { codyMarchData } from './codyMarchData';
import { codySalesData } from './codySalesData'; // April
import { codyMayData } from './codyMayData';
import { codySalesJuneData } from './codySalesJuneData';
import { codySalesJulyData } from './codySalesJulyData';
import { codySalesAugustData } from './codySalesAugustData';
import { codySalesSeptemberData } from './codySalesSeptemberData';
import { codySalesOctoberData } from './codySalesOctoberData';
import { codySalesNovemberData } from './codySalesNovemberData';
import { codySalesDecemberData } from './codySalesDecemberData';

// REMINDER: When adding a new month:
// 1. Import the new Cody month's data above
// 2. Add it to the allMonthlyReports array below
// 3. Update the endMonth in the period object
// 4. Update the CC-YTD report component titles
// 5. Note: Cody file naming is inconsistent (some are codyXXXData, some are codySalesXXXData)

// All Cody monthly reports to aggregate for YTD
const allMonthlyReports = [
  codyJanuaryData,
  codyFebruaryData,
  codyMarchData,
  codySalesData, // April (named differently)
  codyMayData,
  codySalesJuneData,
  codySalesJulyData,
  codySalesAugustData,
  codySalesSeptemberData,
  codySalesOctoberData,
  codySalesNovemberData,
  codySalesDecemberData
  // Full year 2025 complete (January-December)
];

// Combine all Cody monthly reports into YTD data
const combinedData = combineReports(allMonthlyReports, 'Cody YTD Report 2025');

// Export the Cody YTD data with proper period information
export const codySalesYTDData: ReportData = {
  ...combinedData,
  period: {
    month: 12, // Current month for YTD (Full Year 2025)
    startMonth: 1,
    endMonth: 12, // Full year 2025 complete
    year: 2025,
    ytd: true
  }
};